// This indicates the scenario under which we want to provide default content
// Possible types: 
//  MissingFile: Use this scenario for paths that do not exist
export class Scenario {
    public static MissingFile: string = "MissingFile";
}